<template>
    <div>
        <h1>Logout</h1>
        <p>Welcome to your Logout</p>
    </div>
</template>

<script>
export default {
    name: 'LogoutView',
}
</script>